import { render, staticRenderFns } from "./selectWord.vue?vue&type=template&id=1cf61de6&scoped=true&"
import script from "./selectWord.vue?vue&type=script&lang=js&"
export * from "./selectWord.vue?vue&type=script&lang=js&"
import style0 from "./selectWord.vue?vue&type=style&index=0&id=1cf61de6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf61de6",
  null
  
)

export default component.exports